import React from 'react'
import { shallow } from 'enzyme'
import SectionResolver from '../SectionResolver'

describe('SectionResolver', () => {
  let wrapper, props

  beforeAll( () => {
    props = {
      loanId: 22,
      customerService: true,
      section: "PayrollInfo",
      client: {}
    }
    wrapper = shallow(<SectionResolver {...props} />)
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })
})